<template>
  <div class="content">
    <div class="row text-left">
      <div class="col-md-12">
        <p class="text-black-50">
          Новая компенсация
          <i v-on:click="addNewOne" class="tim-icons icon-money-coins"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" tuning="true" :a-page="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const compensationBaseTSR = {header: "Базовое ТСР", name: "baseTSR.name", show: true, sort: true, direction: true};
const compensationDisabledCategory = {header: "Категория инвалидности", name: "disabledCategory.name", show: true, sort: true, direction: true};
const compensationLimit = {header: "Сумма компенсации", name: "limit.0.value", show: true, sort: true, direction: true};
const compensationStart = {header: "Начало действия", name: "limit.0.startDate", show: true, sort: true, direction: true};

export default{
  data() {
    return {
      type: "compensation",
      content: [compensationBaseTSR, compensationDisabledCategory, compensationLimit, compensationStart],
      newOne: null
    }
  },
  methods: {
    addNewOne() {
      let object = {id: 0, limit: [], baseTSR:{}, disabledCategory:{}};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
